import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fanhui",
  "use": "icon-fanhui-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-fanhui\">\r\n<path d=\"M91.5,46.3V15.8c-2.7-12.7-13-5-13-5L7.3,73.5C-8.4,84.5,6.2,92.9,6.2,92.9l70.2,62.1c14,10.5,15.1-5.5,15.1-5.5v-28.3\r\n\tc71.3-22.7,100.4,68.2,100.4,68.2c2.7,5,4.3,0,4.3,0C223.8,53,91.5,46.3,91.5,46.3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol